// extracted by mini-css-extract-plugin
export default {"container":"deal-form_container__7NA1E","truncate-table":"deal-form_truncate-table__F6E0P","table-text-faded":"deal-form_table-text-faded__LRv5g","form":"deal-form_form__LgjQH","actions":"deal-form_actions__-g3-P"};
    if(module.hot) {
      // 1793877089291
      var cssReload = require("!../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  